export default __webpack_public_path__ + "static/media/newsPage.7730e011.jpg";